const carouselHero = (slide_time = 2000) => {

    let heroTimeout = null;

    const carousel_class = ".hero-carousel";


    function stopInterval() {
        clearInterval(heroTimeout);
    }

    let $carousel = jQuery(carousel_class);


    let siema = new Siema({
        selector: carousel_class,
        perPage: 1,
        startIndex: 0,
        draggable: true,
        multipleDrag: false,
        threshold: 20,
        duration: 0,
        loop: true,
        onInit: function() {
            let _this = this;
            heroTimeout = setInterval(function() {_this.next(); highlightButton(_this.currentSlide);}, slide_time);
        },
        onChange: function() {

            $carousel.find(".anim-ready").removeClass("anim-done");
            setTimeout(function() {
                $carousel.find(".anim-ready").addClass("anim-done");
            }, 300);

        }
    });

    let $btn_nav = jQuery(".hero-nav button");

    let highlightButton = (index) => {
        $btn_nav.removeClass("active");
        $btn_nav.eq(index).addClass("active");
    };

    $btn_nav.on("click", function() {

        stopInterval();

        let $this = jQuery(this);
        let index = $this.index();

        highlightButton(index);

        siema.goTo(index);

    });

};

const carouselCapabilities = () => {

    let $carousel = jQuery(".carousel-services");

    $carousel.on("webkitAnimationEnd oAnimationEnd msAnimationEnd animationEnd", function(event) {
        $carousel.removeClass("anim-from--zoomin anim-done");
    });

    let siema = new Siema({
        selector: '.carousel-services',
        perPage: 1,
        startIndex: 0,
        draggable: false,
        multipleDrag: false,
        threshold: 20,
        loop: true,
        onInit: () => {},
        onChange: function() {

            $carousel.addClass("anim-from--right anim-done"); 

        }
    });

    let highlightButton = (index) => {
        jQuery('button[data-service-item]').removeClass("active");
        jQuery('button[data-service-item="'+index+'"]').addClass("active");
    };

    jQuery(".service-carousel--controls__prev").on("click", function() {
        siema.prev();
        highlightButton(siema.currentSlide);
    });

    jQuery(".service-carousel--controls__next").on("click", function() {
        siema.next();
        highlightButton(siema.currentSlide);
    });

    jQuery("button.service-item").on("click", function() {
        let index = jQuery(this).attr("data-service-item");
        highlightButton(index);
        siema.goTo(index);
    });

    if (jQuery(".service-carousel").length > 0) {

        jQuery(".service-item").on("click", function() {
            if (jQuery(window).width() < 768) {
                jQuery('html, body').animate({
                    scrollTop: jQuery(".service-carousel").offset().top - 100
                }, 500);
            }
        });

    }

};

const carouselPartners = (slide_time = 2000) => {

    let badgesTimeout = null;

    let badges = new Siema({
        selector: ".badges-inline",
        perPage: 5,
        draggable: false,
        multipleDrag: false,
        loop: true,
        onInit: function() {
            let _this = this;
            badgesTimeout = setInterval(function() {_this.next()}, slide_time);
        }
    });

    jQuery(".badges-carousel--controls__prev").on("click", function() {
        badges.prev();
    });

    jQuery(".badges-carousel--controls__next").on("click", function() {
        badges.next();
    });

    if (jQuery(window).width() < 768) {

        clearTimeout(badgesTimeout);
        badges.config.perPage = 2;
        badges.perPage = 2;
        badges.init();

    }

    window.addEventListener("resize", function() {

        setTimeout(function() {

            clearTimeout(badgesTimeout);
            badges.destroy();

            if (jQuery(window).width() < 768) {

                badges.config.perPage = 2;
                badges.perPage = 2;
                badges.init();

            }
            else {

                badges.config.perPage = 5;
                badges.perPage = 5;
                badges.init();

            }

        }, 1000);

    });

};